export default {
    // URL: 'https://localhost:7152',
    // URL: 'https://ntw-api.devaidsoft.net', // Dev
    URL: 'https://api.syscallsafe.com', // Live
    ROUTES: {
        register: '/',
    },
    HEADERS: {
        AppID: 'a016878d-e2ff-4ea6-876b-195125445df5',
        AppKey: 'vKahY3N3K1wf1J7GSmZHMIkodEFBAlTuZ6bIBbUSCgjfTHKz1lix877HN9hUF0zO',
    },
};
